import { Badge } from '@/components/ui';
import type { ConversationSurface } from '@/lib/api';
import { cn } from '@/lib/utils';
import { SURFACES } from './surfaces';
import './surfaces.css';

export interface OrigemTagProps {
  surface: ConversationSurface;
  className?: string;
}

/**
 * A tag da origem de uma conversa. `Badge` neutro: a cor fica só no ícone, para
 * quatro tags lado a lado numa lista não virarem um arco-íris, e o nome escrito
 * carrega o sentido sozinho.
 */
export function OrigemTag({ surface, className }: OrigemTagProps): JSX.Element {
  const { label, icon: Icon } = SURFACES[surface];
  return (
    <Badge
      className={cn('origem-tag', `origem-tag--${surface}`, className)}
      icon={<Icon strokeWidth={2} />}
    >
      {label}
    </Badge>
  );
}
